/* ==========================================================================
   Écran verrouillé Alfa — DÉCOR SEULEMENT.
   L'accès est 100 % serveur : le formulaire de layout/password.liquid fait
   un POST natif que Shopify valide (bon code → redirection) ou rejette
   (rechargement avec form.errors → classe `etat-erreur` posée sur <body>
   par Liquid, chorégraphie d'erreur jouée au paint par le CSS).
   Ce fichier ne porte AUCUNE logique d'accès ; la page fonctionne sans lui.
   Il n'anime que le décor : parallaxe, regard/penchement du doggo,
   pulsation du halo à la frappe.
   ========================================================================== */
(function(){
  'use strict';
  var calme = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var racine = document.documentElement;
  var doggo = document.getElementById('doggo');
  var lean = document.getElementById('d-lean');
  var champ = document.getElementById('acces');
  var minuterieImpulsion = null;
  var desole = false;

  /* Parallaxe + regard + penchement — purement décoratif : aucune logique
     d'accès ne vit dans une boucle d'animation (WebView iOS gèle le rAF). */
  var tx = 0, ty = 0, px = 0, py = 0, viseChamp = false;
  window.addEventListener('pointermove', function(e){
    tx = (e.clientX / window.innerWidth) * 2 - 1;
    ty = (e.clientY / window.innerHeight) * 2 - 1;
  }, {passive:true});
  window.addEventListener('deviceorientation', function(e){
    if (e.gamma === null || e.beta === null) return;
    tx = Math.max(-1, Math.min(1, e.gamma / 30));
    ty = Math.max(-1, Math.min(1, (e.beta - 45) / 35));
  }, {passive:true});
  function boucle(){
    px += (tx - px) * .06;
    py += (ty - py) * .06;
    racine.style.setProperty('--px', px.toFixed(4));
    racine.style.setProperty('--py', py.toFixed(4));
    if (doggo && lean){
      var l, gx, gy;
      if (desole){ l = 0; gx = -4; gy = 8; }
      else if (viseChamp){ l = 6; gx = -4; gy = 16; }
      else { l = px * 3.5; gx = px * 22; gy = py * 12 + 2; }
      lean.style.setProperty('--lean', l.toFixed(2));
      doggo.style.setProperty('--gx', gx.toFixed(2));
      doggo.style.setProperty('--gy', gy.toFixed(2));
    }
    window.requestAnimationFrame(boucle);
  }
  if (!calme) window.requestAnimationFrame(boucle);

  if (champ){
    /* Il se penche vers le champ, il a hâte */
    champ.addEventListener('focus', function(){
      viseChamp = true;
      if (!calme) document.body.classList.add('vise');
    });
    champ.addEventListener('blur', function(){
      viseChamp = false;
      document.body.classList.remove('vise');
    });

    /* Chaque frappe : UNE pulsation — son halo bat, il se redresse, la
       chaleur du trait respire. Rien d'autre ne s'allume. */
    var derniereImpulsion = 0;
    champ.addEventListener('input', function(){
      if (calme) return;
      var t = Date.now();
      if (t - derniereImpulsion < 150) return;
      derniereImpulsion = t;
      document.body.classList.remove('impulsion');
      void document.body.offsetWidth; /* réarme la pulsation */
      document.body.classList.add('impulsion');
      if (minuterieImpulsion) window.clearTimeout(minuterieImpulsion);
      minuterieImpulsion = window.setTimeout(function(){
        document.body.classList.remove('impulsion');
      }, 360);
    });
  }

  /* Erreur serveur (classe posée par Liquid, chorégraphie CSS au paint) :
     le doggo a un court temps de gêne, puis le champ reprend le focus —
     après l'attache des écouteurs, pour que le regard « vise » suive.
     Rien de plus : aucune validation, aucun état d'accès ici. */
  if (document.body.classList.contains('etat-erreur')){
    desole = true;
    window.setTimeout(function(){ desole = false; }, 1300);
    if (champ) champ.focus();
  }
})();
